import { EmailTemplateSender } from "@/models/admin/emailTemplates/emailTemplates.types"
import { SoChipType } from "@/types/components/SoChip"

const WARNINGS: Partial<Record<EmailTemplateSender, string>> = {
  [EmailTemplateSender.JUNIFER]:
    "This template is read-only. Please update directly in Junifer Client.",
}

const CHIP_TYPES: Partial<Record<EmailTemplateSender, SoChipType>> = {
  [EmailTemplateSender.NOVA]: SoChipType.IMPORTANT,
  [EmailTemplateSender.JUNIFER]: SoChipType.SUCCESS,
}

// External sources track no author, so the owning client stands in for one.
const MODIFIED_BY: Partial<Record<EmailTemplateSender, string>> = {
  [EmailTemplateSender.JUNIFER]: "Junifer UI",
}

export function senderReadOnlyWarning(sender: EmailTemplateSender): string {
  return (
    WARNINGS[sender] ??
    "This template is read-only. Please update directly in the source system."
  )
}

export function senderChipType(sender: EmailTemplateSender): SoChipType {
  return CHIP_TYPES[sender] ?? SoChipType.DEFAULT
}

export function senderModifiedBy(sender: EmailTemplateSender): string {
  return MODIFIED_BY[sender] ?? sender
}
